import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'instituto-enso';

  ngOnInit() {
    setTimeout(() => {
      window.location.href = 'https://institutoinvicta.com.br/';
    }, 3000);
  }

  shouldDisplayCookiesComponent(): boolean {
    return environment.ambiente === 'environment.hml'; 
  }

  shouldDisplayCookies(): boolean {
    return this.shouldDisplayCookiesComponent();
  }
}
